
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, namespace } from 'vuex-class'
import { getEnvironments } from '@/environments'
const env = getEnvironments()

const ACCOUNT_MODULE = 'account'

@Component({
  components: {
  }
})
export default class UserEdit extends Vue {
  @Action('passwordUpdate', { namespace: ACCOUNT_MODULE })
  passwordUpdate!: any

  @Action('alertUpdate', { namespace: ACCOUNT_MODULE })
  alertUpdate!: any

  @Getter('passwordUpdated', { namespace: ACCOUNT_MODULE })
  passwordUpdated!: any

  @Getter('alertUpdated', { namespace: ACCOUNT_MODULE })
  alertUpdated!: any

  @Getter('alertaCorreo', { namespace: ACCOUNT_MODULE })
  alertaCorreo!: string

  selected: number = 1
  repeatPassword: string = ''
  newPassword: string = ''

  email: string = ''
  phone: string = ''

  created () {
    this.email = this.alertaCorreo
  }

  selectOption (index: number) {
    this.selected = index
  }

  async savePassword ({ newPassword, repeatPassword }: any) {
    const password01 = (newPassword || '').trim()
    const password02 = (repeatPassword || '').trim()
    if (password01 !== password02) {
      this.$notify({
        group: 'alert-group',
        type: 'error',
        text: 'Las contraseñas no corresponden'
      })
      return
    }
    if (password01.length === 0 || password02.length === 0) {
      this.$notify({
        group: 'alert-group',
        type: 'error',
        text: 'La contraseña no puede ser vacía'
      })
      return
    }
    await this.passwordUpdate(newPassword)
    if (this.passwordUpdated.status === 200) {
      this.$notify({
        group: 'alert-group',
        text: 'Contraseña actualizada con éxito',
        duration: 10000
      })
    } else {
      this.$notify({
        group: 'alert-group',
        text: 'Ocurrió un error al actualizar la contraseña',
        duration: 10000
      })
    }
  }

  async saveAlert ({ alertaMovil, alertaCorreo }: any) {
    await this.alertUpdate({ alertaMovil, alertaCorreo })
    if (this.alertUpdated.status === 200) {
      this.$notify({
        group: 'alert-group',
        text: 'Contactos actualizados con éxito',
        duration: 10000
      })
    } else {
      this.$notify({
        group: 'alert-group',
        text: 'Ocurrió un error al actualizar los contactos',
        duration: 10000
      })
    }
  }
}
